import { startTransition, StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import browserClient from '@slardar/web';
import { setAgentTelemetrySink } from './sites/agent/telemetry';
import App from './App';
import { getRoutes } from './routes/index';
import './utils/responsive';

browserClient('init', {
  bid: 'chartspace_site',
  env: __DEV__ ? 'test' : `production(${location.host})`,
});
browserClient('start');
setAgentTelemetrySink((event) => browserClient('sendEvent', event));

// The server owns production host policy. Plain Vite development has no SSR
// decision, so allow loopback only; missing production metadata fails closed.
const agentEnabled =
  __AGENT_ENABLED__ &&
  (document.querySelector<HTMLMetaElement>(
    'meta[name="visactor-agent-enabled"]'
  )?.content === 'true' ||
    (__DEV__ &&
      ['localhost', '127.0.0.1', '[::1]'].includes(location.hostname)));

startTransition(() => {
  hydrateRoot(
    document.getElementById('root')!,
    <StrictMode>
      <App
        hostname={location.hostname}
        userAgent={navigator.userAgent}
        agentEnabled={agentEnabled}
      >
        <RouterProvider router={createBrowserRouter(getRoutes(agentEnabled))} />
      </App>
    </StrictMode>
  );
});
